export const SPECIALTIES = [
  "Local Food Tours",
  "City Walking Tours",
  "Photography Spots",
  "Cultural Experiences",
  "Adventure Activities",
  "Historical Sites",
  "Art Galleries",
  "Music Venues",
  "Hidden Gems",
  "Nature Spots",
  "Local Markets",
  "Traditional Crafts",
  "Language Exchange",
  "Cooking Classes",
  "Nightlife Guide",
  "Sports Activities"
];